// // src/components/InvestorPage.jsx
// import React from "react";
// import "./InvestorPage.css";
// import orthopedicnewimage from "../../images/ortho-pedic-new-hero-image.jpg"

// export default function InvestorPage({
//   logoUrl = "/assets/logo.png",
//   deckUrl = "/assets/investor-deck.pdf",
//   contactEmail = "funding@sabiote.in",
//   calendlyUrl = "https://calendly.com/your-calendar",
// }) {
//   return (
//     <div className="homepage-wrapper investio-details-page">

//       {/* ---------------- HERO SECTION ---------------- */}
//       <section className="homepage-hero">
//         <h1 className="homepage-hero-title">Sabiote Healthcare</h1>
//         <p className="homepage-hero-subtext">
//           Innovating Orthopaedic Surgical Devices — Made in India
//         </p>

//         <div className="homepage-hero-buttons">
//           <a href={deckUrl} download className="homepage-btn-outline">
//             Request Investor Deck
//           </a>
//           <a href={`mailto:${contactEmail}`} className="homepage-btn-outline">
//             Contact Us
//           </a>
//         </div>
//       </section>

//       {/* ---------------- HERO #2 ---------------- */}
//       <section className="investio-hero2">
//         <div className="hero-text">
//           <h2 className="hero-title">Investing in India’s Orthopaedic Future</h2>
//           <p className="hero-desc">
//             Building the first indigenous platform for advanced orthopaedic surgical devices —
//             starting with our Disposable Pulse Lavage System.
//           </p>

//           <div className="hero-buttons">
//             <a href={deckUrl} download className="btn-primary">
//               Request Investor Deck
//             </a>

//             <a href={calendlyUrl} target="_blank" rel="noopener noreferrer" className="btn-outline">
//               Schedule a Call
//             </a>
//           </div>
//         </div>

//         <div className="hero-image-box">

//           <div className="hero-placeholder">
//              <img src={orthopedicnewimage} alt="orthopedic Image" />

//           </div>
//         </div>
//       </section>

//       {/* ---------------- MISSION ---------------- */}
//       <section className="investio-mission">
//         <h3 className="section-title">Our Mission</h3>
//         <p className="section-text">
//           Reduce India’s dependence on imported surgical devices by designing and manufacturing
//           globally competitive, affordable, and scalable orthopaedic consumables.
//         </p>
//       </section>

//       {/* ---------------- WHY SABIOTE ---------------- */}
//       <section className="investio-why">
//         <h3 className="section-title">Why Sabiote</h3>

//         <div className="grid-4">
//           <Card title="Indigenous MedTech Innovation">
//             Among the first to build India-manufactured alternatives in categories dominated by imports.
//           </Card>

//           <Card title="Validated Clinical Performance">
//             Multi-batch surgeon validation and early adoption in hospitals.
//           </Card>

//           <Card title="Scalable Manufacturing">
//             Dual-location model: process engineering + sterile packaging at Noida.
//           </Card>

//           <Card title="Market & Distribution Access">
//             Deep relationships with surgeons, procurement teams & distributors.
//           </Card>
//         </div>
//       </section>

//       {/* ---------------- TRACTION + MARKET ---------------- */}
//       <section className="investio-traction-market">
//         <div className="grid-2">

//           <div>
//             <h3 className="section-title">Traction & Momentum</h3>
//             <ul className="list">
//               <li><span>✓</span> Early institutional adoption</li>
//               <li><span>✓</span> Repeat orders and strong clinical reliability</li>
//               <li><span>✓</span> Multi-batch surgeon validation completed</li>
//               <li><span>✓</span> Growing distributor network</li>
//             </ul>
//           </div>

//           <div>
//             <h3 className="section-title">Market Opportunity</h3>
//             <p className="section-text">
//               The orthopaedic consumables market is large, import-driven and growing.
//               India’s unmet needs and the global China+1 shift create strong supply opportunities.
//             </p>

//             <div className="note-box">
//               For investor conversations, we share a detailed market memo on request.
//             </div>
//           </div>

//         </div>
//       </section>

//       {/* ---------------- PIPELINE ---------------- */}
//       <section className="investio-pipeline">
//         <h3 className="section-title">Product Pipeline</h3>

//         <div className="pipeline-list">
//           <PipelineItem
//             title="NOW – Pulse Lavage"
//             desc="Commercial and validated; scaling across institutions."
//           />

//           <PipelineItem
//             title="NEXT 12 MONTHS – Ortho Power Drill"
//             desc="Prototype → MVP; substitutes imported systems."
//           />

//           <PipelineItem
//             title="FUTURE – Bone Cement & Synthetic Graft"
//             desc="High-value consumables expanding margins."
//           />
//         </div>
//       </section>

//       {/* ---------------- TEAM ---------------- */}
//       <section className="investio-team">
//         <h3 className="section-title">Team</h3>

//         <div className="grid-3">
//           <TeamCard
//             name="Satish Kumar Mishra"
//             title="Founder & MD"
//             bio="17+ years in product ops and orthopaedic devices."
//           />

//           <TeamCard
//             name="Alok Verma"
//             title="COO"
//             bio="30+ years in supply chain and manufacturing scale-up."
//           />

//           <TeamCard
//             name="Pappu Mishra"
//             title="CBO"
//             bio="10+ years in orthopaedic sales and distributor networks."
//           />
//         </div>
//       </section>

//       {/* ---------------- FOOTER CTA ---------------- */}
//       <footer className="investio-footer">
//         <h4 className="footer-title">Interested in speaking with us?</h4>

//         <div className="footer-buttons">
//           <a href={deckUrl} download className="btn-primary-large">
//             Request Investor Deck
//           </a>

//           <a href={calendlyUrl} target="_blank" rel="noopener noreferrer" className="btn-outline-large">
//             Schedule a Call
//           </a>
//         </div>

//         <p className="footer-email">
//           Email: <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
//         </p>
//       </footer>

//     </div>
//   );
// }

// /* ---------------- SMALL COMPONENTS ---------------- */

// function Card({ title, children }) {
//   return (
//     <div className="card">
//       <h4 className="card-title">{title}</h4>
//       <p className="card-text">{children}</p>
//     </div>
//   );
// }

// function PipelineItem({ title, desc }) {
//   return (
//     <div className="pipeline-item">
//       <div className="dot" />
//       <div>
//         <h5 className="pipeline-title">{title}</h5>
//         <p className="pipeline-desc">{desc}</p>
//       </div>
//     </div>
//   );
// }

// function TeamCard({ name, title, bio }) {
//   return (
//     <div className="team-card">
//       <div className="team-avatar">
//         {name
//           .split(" ")
//           .slice(0, 2)
//           .map((n) => n[0])
//           .join("")}
//       </div>

//       <div>
//         <div className="team-name">{name}</div>
//         <div className="team-role">{title}</div>
//         <div className="team-bio">{bio}</div>
//       </div>
//     </div>
//   );
// }
import React from "react";
import "./InvestorPage.css";
import satish from "../../images/satish-mishra.jpg"
import Alok from "../../images/alok- verma.jpg"
import  Pappu from "../../images/pappu -mishra.jpg"


export default function InvestorPage() {
  return (
    <main className="investor-page page-wrapper">
      {/* HERO */}
      <section className="investor-page-hero hero-section">
        <div className="hero-left">
          <div className="hero-badge">
            DPIIT-Recognised MedTech Manufacturer
          </div>

          <h1 className="hero-title">Investor Overview &amp; Collaboration</h1>

          <p className="hero-text">
            Sabiote Healthcare is building India’s first platform for indigenous
            orthopaedic consumables — starting with Disposable Pulse Lavage and
            expanding into Bone Cement, Bone Grafts and Ortho Power Systems.
          </p>

          <div className="hero-actions">
            <a
              className="homepage-btn-outline"
              href="mailto:satish@sabiote.in?subject=Inquiry&body=Hello%20I%20have%20a%20question."
            >
              Request Investor Deck
            </a>

            <a
              className="homepage-btn-outline"
              href="mailto:satish@sabiote.in?subject=Inquiry&body=Hello%20I%20have%20a%20question."
            >
              Schedule a Call
            </a>
          </div>
        </div>

        <aside className="hero-side-card">
          <h2 className="side-title">At a Glance</h2>

          <div className="hero-metrics">
            <div className="metric-item">
              <div className="metric-label">Cumulative supplies</div>
              <div className="metric-value">₹16 Cr+</div>
            </div>

            <div className="metric-item">
              <div className="metric-label">Institutions served</div>
              <div className="metric-value">30+ hospitals</div>
            </div>

            <div className="metric-item">
              <div className="metric-label">GeM orders</div>
              <div className="metric-value">646+</div>
            </div>

            <div className="metric-item">
              <div className="metric-label">GeM rating</div>
              <div className="metric-value">4.42 / 5</div>
            </div>
          </div>
        </aside>
      </section>

      {/* OVERVIEW SECTION */}
      <section className="investor-page-section overview-section">
        <h2 className="section-title">Overview</h2>

        <div className="section-body section-cols">
          <div className="overview-left">
            <p className="muted">
              India performs 5.6M+ orthopaedic surgeries every year, yet most
              critical consumables are fully imported, making surgeries
              expensive and limiting access in Tier-2/3 hospitals.
            </p>
          </div>

          <div className="overview-right">
            <ul className="custom-list">
              <li>Pulse Lavage, Bone Cement &amp; Grafts are 100% imported.</li>
              <li>
                Government schemes face cost pressure; reuse or skipping of
                consumables is common.
              </li>
              <li>
                Emerging markets across Asia &amp; Africa have the same problem:
                high-cost imported devices, no local alternatives.
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* SOLUTION SECTION */}
      <section className="investor-page-section solution-section">
        <h2 className="section-title">Solution &amp; Product Line</h2>

        <div className="section-body section-cols">
          <div className="solution-left">
            <h3 className="sub-title">Disposable Pulse Lavage (Commercial)</h3>

            <ul className="custom-list">
              <li>
                India’s first indigenously manufactured Pulse Lavage system.
              </li>
              <li>Single-use, sterile, validated in real ortho surgeries.</li>
              <li>
                Designed with Future Factory; assembly in Mumbai, final QC &amp;
                sterile packaging in our Noida facility.
              </li>
              <li>
                Up to ~40% more cost-efficient than imported alternatives.
              </li>
            </ul>
          </div>

          <div className="solution-right">
            <h3 className="sub-title">Pipeline (In Development)</h3>

            <ul className="custom-list">
              <li>Orthopaedic Power Drill system (MVP under development).</li>
              <li>Bone Cement for joint replacement &amp; trauma use.</li>
              <li>Synthetic Bone Grafts &amp; substitutes.</li>
            </ul>

            <div className="pill-list">
              <span className="pill">High import dependence</span>
              <span className="pill">Regulated consumables</span>
              <span className="pill">Recurring demand</span>
            </div>
          </div>
        </div>
      </section>

      {/* TRACTION SECTION */}
      <section className="investor-page-section traction-section">
        <h2 className="section-title">Traction &amp; Market</h2>

        <div className="section-body section-cols">
          <div className="traction-left">
            <h3 className="sub-title">Execution so far</h3>

            <ul className="custom-list">
              <li>
                ₹16 Cr+ supplies delivered to govt &amp; private hospitals.
              </li>
              <li>646+ orders executed on GeM with 4.42/5 seller rating.</li>
              <li>
                Early clinical validation for Pulse Lavage and Bone Cement
                through orthopaedic surgeon network.
              </li>
            </ul>
          </div>

          <div className="traction-right">
            <h3 className="sub-title">Market snapshot</h3>

            <ul className="custom-list">
              <li>Pulse Lavage India: ~₹120–150 Cr, 100% imported.</li>
              <li>
                Bone Cement &amp; Bone Grafts India: ~₹900 Cr+ combined by 2030.
              </li>
              <li>
                Strong “China+1” opportunity as OEMs diversify supply chains.
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* WHY SABIOTE */}
      <section className="investor-page-section why-section">
        <h2 className="section-title">Why Sabiote</h2>

        <div className="section-body card-grid">
          <div className="card why-card">
            <h3>First mover</h3>
            <p>
              {" "}
              One of the first Indian manufacturers with a validated Pulse
              Lavage system in a historically import-only category.
            </p>
          </div>

          <div className="card why-card">
            <h3>Cost &amp; process advantage</h3>
            <p>
              {" "}
              Design IP filed, dual-location manufacturing and stable
              sterilisation process give sustainable cost and quality edge.
            </p>
          </div>

          <div className="card why-card">
            <h3>Clinical &amp; channel access</h3>
            <p>
              {" "}
              Established relationships with surgeons, institutions and dealers
              built over years of supplying ortho consumables.
            </p>
          </div>
        </div>
      </section>

      {/* TEAM */}
      <section className="investor-page-section team-section">
        <h2 className="section-title">Team</h2>

        <div className="section-body team-grid">
          <div className="team-member">
            <div className="team-img">
              <img src={satish} alt="satish mishra" />
            </div>
            <h3>Satish Mishra</h3>
            <div className="team-role">Founder &amp; Managing Director</div>
            <p className="muted">
              17+ years in operations, Six Sigma and orthopaedic devices; leads
              product, strategy and execution.
            </p>
          </div>

          <div className="team-member">
            <div className="team-img">
             <img src={Alok} alt="Alok Verma" />
            </div>
            <h3>Alok Verma</h3>
            <div className="team-role">COO</div>
            <p className="muted">
              30+ years in supply chain &amp; manufacturing (ex-Dabur);
              responsible for plant, vendors and quality systems.
            </p>
          </div>

          <div className="team-member">
            <div className="team-img">
              <img src={Pappu} alt="pappu mishra" />
            </div>
            <h3>Pappu Mishra</h3>
            <div className="team-role">CBO</div>
            <p className="muted">
              10+ years in orthopaedic sales &amp; surgeon relationships; drives
              tenders, dealer network and private hospital business.
            </p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="investor-page-section cta-section">
        <h2 className="section-title">Current Raise</h2>

        <div className="section-body">
          <p className="muted">
            We are currently exploring partnerships with long-term investors who
            understand healthcare and manufacturing and can support:
          </p>

          <ul className="custom-list">
            <li>Scaling Pulse Lavage manufacturing and inventory.</li>
            <li>Advancing Bone Cement &amp; Bone Graft development.</li>
            <li>Bringing the Orthopaedic Power Drill MVP to market.</li>
            <li>Deepening hospital &amp; dealer coverage across India.</li>
          </ul>

          <div className="cta-panel">
            <div className="cta-left">
              <strong>Interested in exploring this further?</strong>
              <div>
                {" "}
                Share your details to receive our investor deck and a
                founder-level overview.
              </div>
            </div>

            <div className="cta-actions">
              <a
                className="btn btn-primary"
                href="mailto:satish@sabiote.in?subject=Investor%20Deck%20Request"
              >
                Request Deck
              </a>
              <a
                className="btn btn-ghost"
                href="mailto:satish@sabiote.in?subject=Schedule%20Investor%20Call"
              >
                Talk to Founder
              </a>
            </div>
          </div>
        </div>
      </section>

      <footer className="investor-footer">
        This page is for informational purposes only and does not constitute an
        offer to sell securities. Detailed information is shared selectively
        with verified investors.
      </footer>
    </main>
  );
}
